import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import { lazy, Suspense } from "react";
import { Row, Spin } from "antd";
import { ErrorBoundary } from "react-error-boundary";
import ErrorHandler from "./store/ErrorHandler";

//  router
const PrivateRoute = lazy(() => import("./router/PrivateRoute"));

//  Pages
const LoginPage = lazy(() => import("./pages/auth/LoginPage"));
// const JoinPage = lazy(() => import("./pages/auth/JoinPage"));
// const HomePage = lazy(() => import('./pages/main/HomePage'));
const ViewCasePage = lazy(() => import("./pages/main/ViewCasePage"));
const ReviewDataPage = lazy(() => import("./pages/main/ReviewDataPage"));
const InquiryPage = lazy(() => import("./pages/main/InquiryPage"));
const SchedulePage = lazy(() => import("./pages/main/SchedulePage"));

//  Error
const ErrorPage = lazy(() => import("./pages/error/ErrorPage"));

function App() {
	return (
        <Router>
            <ErrorBoundary FallbackComponent={ErrorHandler}>
                <Suspense
                    fallback={
                        <Row justify="center" align="middle" style={{ minHeight: "100vh" }}>
                            <Spin size="large" />
                        </Row>
                    }
                >
                    <Routes>
                        <Route element={<AppLayout />}>
                            <Route path="/" element={<LoginPage />} />
                            {/*<Route path='/join' element={<JoinPage />} />*/}
                            <Route element={<PrivateRoute />}>
                                {/*<Route path='/home' element={<HomePage />} />*/}
                                <Route path="/case" element={<ViewCasePage />} />
                                <Route path="/review/:caseId" element={<ReviewDataPage />} />
                                <Route path="/inquiry" element={<InquiryPage />} />
                                <Route path="/schedule" element={<SchedulePage />} />
                                <Route path="/schedule/:caseId" element={<SchedulePage />} />
                            </Route>
                        </Route>
                        <Route path="*" element={<ErrorPage />} />
                    </Routes>
                </Suspense>
            </ErrorBoundary>
        </Router>
    );
}

export default App;
